<template>
  <div class="min-h-screen bg-[#FAFAF8] px-6 py-12">
    <div
      class="max-w-4xl mx-auto bg-white rounded-xl shadow-sm p-8 border border-gray-100 space-y-6"
    >
      <h1 class="text-3xl font-extrabold text-[#0B2447]">
        Conditions Générales d'Utilisation
      </h1>

      <section class="space-y-3">
        <h2 class="text-lg font-bold text-orange-600">
          1. Objet de la plateforme
        </h2>
        <p class="text-gray-600 text-sm leading-relaxed">
          L'application Giraaf Workflow est un outil collaboratif destiné à la
          gestion de projets, de tâches et d'activités pour les professionnels
          et entreprises.
        </p>
      </section>

      <section class="space-y-3">
        <h2 class="text-lg font-bold text-orange-600">
          2. Obligations de l'utilisateur
        </h2>
        <p class="text-gray-600 text-sm leading-relaxed">
          Chaque utilisateur s'engage à fournir des informations véridiques lors
          de son inscription et à utiliser l'application de manière légale et
          conforme à la législation en vigueur.
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CguView'
}
</script>
